import type { Namespace } from '@govard/i18n-core';

export const shellRu: Namespace = {
  'language.label': 'Язык',
  'language.ru': 'RU',
  'language.en': 'EN',
  'sidebar.group_sales': 'Продажи',
  'sidebar.group_tasks': 'Задачи',
  'sidebar.group_content': 'Контент',
  'sidebar.group_analytics': 'Аналитика',
  'sidebar.group_automation': 'Автоматизация',
  'sidebar.group_telegram': 'Telegram',
  'sidebar.group_admin': 'Админка',
  'sidebar.collapse': 'Свернуть боковое меню',
  'sidebar.expand': 'Развернуть боковое меню',
  'sidebar.admin_profile': 'Профиль администратора',
  'sidebar.admin_name': 'Администратор',
  'sidebar.system_owner': 'Владелец системы',
  'topbar.search_placeholder': 'Поиск по GovardOS...',
  'topbar.notifications': 'Уведомления',
  'topbar.settings': 'Настройки',
  'operator.restored': 'Маршрут operator-модуля восстановлен в CRM shell.',
  'operator.parity_title': 'Каркас маршрута',
  'operator.parity_description':
    'Маршрут доступен в app shell для ERP2 parity. Реализация модуля выполняется в [PHASE-2].',
  'operator.skeleton_only': 'Пока доступен только каркас маршрута без runtime-логики.',
  'operator.module.prompt_compiler': 'Компилятор промптов',
  'operator.module.knowledge': 'База знаний',
  'operator.module.files': 'Файлы',
  'operator.module.agent_monitor': 'Монитор агентов',
  'operator.module.opencode': 'OpenCode',
  'system_agent.group_none': 'Система',
  'system_agent.group_workspace': 'Рабочее пространство',
  'system_agent.group_deal': 'Сделки',
  'system_agent.group_contact': 'Контакты',
  'system_agent.session_fallback': 'Сессия {id}',
  'system_agent.global_context': 'глобальный контекст',
  'auth.login.session_error': 'Не удалось сохранить сессию. Повторите попытку.',
  'auth.login.invalid_credentials': 'Неверный email или пароль.',
  'auth.login.email_taken': 'Пользователь с таким email уже существует.',
  'auth.login.rate_limited': 'Слишком много попыток. Попробуйте позже.',
  'auth.login.registration_unavailable': 'Регистрация недоступна в демо-режиме.',
  'auth.login.status_error': 'Ошибка авторизации ({status}).',
  'auth.login.connection_error': 'Не удалось выполнить авторизацию. Проверьте соединение.',
  'auth.guard.unavailable_title': 'Не удалось проверить сессию',
  'auth.guard.unavailable_description':
    'Сервис временно недоступен. Проверьте соединение и повторите попытку.',
  'auth.login.subtitle': 'Войдите в рабочее пространство.',
  'auth.login.register_subtitle': 'Создайте личное пространство.',
  'auth.login.tab_login': 'Вход',
  'auth.login.tab_register': 'Регистрация',
  'auth.login.name': 'Имя',
  'auth.login.name_required': 'Пожалуйста, введите имя',
  'auth.login.name_too_long': 'Имя слишком длинное',
  'auth.login.email': 'Email',
  'auth.login.email_required': 'Пожалуйста, введите email',
  'auth.login.email_invalid': 'Неверный формат email',
  'auth.login.password': 'Пароль',
  'auth.login.password_required': 'Пожалуйста, введите пароль',
  'auth.login.password_min': 'Пароль должен содержать минимум 8 символов',
  'auth.login.submit': 'Войти',
  'auth.login.create_account': 'Создать аккаунт',
  'auth.login.forgot_password': 'Забыли пароль?',
  'auth.email_required': 'Укажите адрес',
  'auth.email_invalid': 'Похоже, это не адрес почты',
  'auth.forgot.rate_limited': 'Слишком много запросов. Попробуйте позже.',
  'auth.forgot.send_error': 'Не удалось отправить письмо. Попробуйте позже.',
  'auth.forgot.title': 'Восстановление пароля',
  'auth.forgot.sent_title': 'Письмо отправлено',
  'auth.forgot.sent_description':
    'Если такой адрес зарегистрирован, на него придёт ссылка для смены пароля. Она действует час.',
  'auth.forgot.back_to_login': 'Вернуться ко входу',
  'auth.forgot.description':
    'Укажите адрес, на который зарегистрирован аккаунт. Пришлём ссылку для смены пароля.',
  'auth.forgot.submit': 'Отправить ссылку',
  'auth.forgot.remembered': 'Вспомнил пароль',
  'auth.verify.title': 'Подтверждение адреса',
  'auth.verify.success_title': 'Адрес подтверждён',
  'auth.verify.success_description': '{email} теперь подтверждён.',
  'auth.verify.open_app': 'В приложение',
  'auth.verify.failed_title': 'Ссылка не сработала',
  'auth.verify.failed_description':
    'Она могла устареть или быть уже использованной. Запросите новое письмо в настройках.',
  'auth.verify.settings': 'В настройки',
  'auth.reset.expired': 'Ссылка больше не действует — запросите новую.',
  'auth.reset.error': 'Не удалось сменить пароль. Попробуйте позже.',
  'auth.reset.title': 'Новый пароль',
  'auth.reset.success_title': 'Пароль изменён',
  'auth.reset.success_description': 'Все прежние сессии закрыты — войдите заново с новым паролем.',
  'auth.reset.to_login': 'Перейти ко входу',
  'auth.reset.description':
    'Придумайте новый пароль — не короче 8 символов. После смены все входы на других устройствах будут закрыты.',
  'auth.reset.new_link': 'Запросить новую ссылку',
  'auth.reset.password': 'Новый пароль',
  'auth.reset.password_required': 'Введите пароль',
  'auth.reset.password_min': 'Не короче 8 символов',
  'auth.reset.repeat': 'Ещё раз',
  'auth.reset.repeat_required': 'Повторите пароль',
  'auth.reset.mismatch': 'Пароли не совпадают',
  'auth.reset.submit': 'Сменить пароль',
  'shared.columns': 'Колонки',
  'shared.reset_view': 'Сбросить вид',
  'shared.configure_columns': 'Настроить колонки',
  'shared.retry': 'Повторить',
  'shared.retry_fallback': 'Попробуйте повторить запрос.',
  'shared.total_count': 'Всего: {count}',
  'shared.delete': 'Удалить',
  'shared.delete_error': 'Не удалось удалить{detail}',
  'shared.overdue': 'Срок прошёл',
  'shared.entity_type.deal': 'Сделка',
  'shared.entity_type.contact': 'Контакт',
  'shared.entity_type.company': 'Компания',
  'shared.entity_type.task': 'Задача',
  'shared.entity_type.project': 'Проект',
  'shared.entity_type.document': 'Документ',
  'shared.entity_type.meeting': 'Встреча',
  'shared.entity_type.template': 'Шаблон',
  'shared.calendar.date': 'Дата',
  'shared.calendar.time': 'Время',
  'shared.calendar.event': 'Событие',
  'shared.calendar.all_day': 'Весь день',
  'shared.calendar.week': 'Неделя',
  'shared.calendar.work_week': 'Рабочая неделя',
  'shared.calendar.day': 'День',
  'shared.calendar.month': 'Месяц',
  'shared.calendar.previous': 'Назад',
  'shared.calendar.next': 'Вперёд',
  'shared.calendar.yesterday': 'Вчера',
  'shared.calendar.tomorrow': 'Завтра',
  'shared.calendar.today': 'Сегодня',
  'shared.calendar.agenda': 'Список',
  'shared.calendar.empty': 'В этом периоде записей нет',
  'shared.calendar.show_more': 'ещё {count}',
  'invite.not_found': 'Такого приглашения нет — возможно, ссылка неполная.',
  'invite.load_error': 'Не удалось открыть приглашение.',
  'invite.wrong_email':
    'Приглашение выписано на другой адрес. Войдите под тем, на который оно пришло.',
  'invite.accept_error': 'Не удалось принять приглашение.',
  'invite.unavailable': 'Приглашение недоступно',
  'invite.invalid': 'Приглашение недействительно',
  'invite.reason_revoked': 'Приглашение отозвали.',
  'invite.reason_accepted': 'Это приглашение уже принято.',
  'invite.reason_expired': 'Срок приглашения истёк — попросите отправить новое.',
  'invite.reason_unknown': 'Ссылка больше не работает.',
  'invite.prefix': 'Вас приглашают в пространство',
  'invite.as_role': 'как {role}',
  'invite.for_email': 'Приглашение выписано на адрес',
  'invite.role_admin': 'администратор',
  'invite.role_member': 'участник',
  'invite.role_viewer': 'наблюдатель',
  'invite.sign_in_description':
    'Чтобы принять, войдите под этим адресом. Если аккаунта ещё нет — зарегистрируйтесь на нём же и вернитесь по этой ссылке.',
  'invite.sign_in': 'Войти или зарегистрироваться',
  'invite.signed_in_as': 'Вы вошли как {email}.',
  'invite.accept': 'Принять приглашение',
  'invite.title': 'Приглашение в Govard CRM',
  'not_found.title': 'Страница не найдена',
  'not_found.description': 'Проверьте адрес или вернитесь на главную страницу.',
  'not_found.home': 'На главную',
  'not_found.login': 'Войти',
  'team.role.owner': 'Владелец',
  'team.role.admin': 'Администратор',
  'team.role.member': 'Участник',
  'team.role.viewer': 'Наблюдатель',
  'team.member_status.active': 'Активен',
  'team.member_status.suspended': 'Отключён',
  'team.member_status.removed': 'Удалён',
  'team.invitation_status.pending': 'Ждёт ответа',
  'team.invitation_status.accepted': 'Принято',
  'team.invitation_status.revoked': 'Отозвано',
  'team.invited_by': 'позвал {name}',
  'shared.inherited_link_tooltip': '{via}: у самой записи привязка не проставлена',
  'shared.inherited_via.contact': 'Через контакт',
  'shared.inherited_via.deal': 'Через сделку',
  'shared.inherited_via.document': 'Через документ',
  'shared.inherited_via.company': 'Через компанию',
  'shared.inherited_via.task': 'Через задачу',
  'shared.inherited_via.meeting': 'Через встречу',
  'shared.inherited_via.template': 'Через шаблон',
  'topbar.theme': 'Тема оформления',
  'topbar.theme_light': 'Светлая',
  'topbar.theme_dark': 'Тёмная',
  'topbar.theme_system': 'Системная',
  'topbar.open_menu': 'Открыть меню',
  'sidebar.close': 'Закрыть',
  'common.reload': 'Перезагрузить',
};
